import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '../../../../../infra/dls/components/button/button';
import styles from './styles.module.scss';
export var LoadingOverlay = function () {
    return (_jsx("div", { className: styles['loading-overlay'], children: _jsx(Button.Primary, { loading: true }) }));
};
